import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./native.css";
import { initCrashlytics } from "@/lib/crashlytics";
import { enableNativeFullBleed } from "@/lib/nativeFullBleed";
import { hideNativeSplash } from "@/lib/nativeSplash";
import { startNativePurchaseReconciler } from "@/lib/nativePurchaseReconciler";
import { registerAppServiceWorker } from "@/lib/registerServiceWorker";

// Native-only bootstrap (all no-ops on the web): render edge to edge so the
// startup screen has no cream bands above and below it, turn on Crashlytics
// crash + non-fatal reporting, and confirm any purchase that completed in the
// system browser while the app was backgrounded.
// Full-bleed goes first — it must land before the first paint.
enableNativeFullBleed();
initCrashlytics();
startNativePurchaseReconciler();
registerAppServiceWorker();

createRoot(document.getElementById("root")!).render(<App />);

// The native launch screen is normally dismissed by ZuzuSplash, the instant
// its own leaf is up, so the two halves of the opening screen cut together.
// This is only for the routes that never render a splash: without it they
// would sit on the leaf until capacitor.config.ts's backstop. Long enough
// that ZuzuSplash always wins the race when it is there at all.
setTimeout(hideNativeSplash, 1500);
